import { identity, isEmpty, isNil } from 'ramda';
import { Field, Form } from 'react-final-form';

import FormSection from 'components/Layouts/Form/FormSection';
import Button from 'components/shared/Button';
import {
  REPLACE_REMOVE_LOGO_PLACEHOLDER,
  UPLOAD_LOGO_PLACEHOLDER,
} from 'components/shared/FormAdapters/FormDefault/FileLogoInput/Logo/constants.js';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Loader from 'components/shared/Loader';
import Text from 'components/shared/Typography/Text';
import { useFormFieldPopup } from 'hooks/useFormFieldPopup';
import useValidationSchema from 'hooks/useValidationSchema';
import { parseHEXColor } from 'utils/common';

import { PartnerItem } from '../PartnerAgentList';
import s from './index.module.css';
import validationSchema from './validationSchema';

function PartnerAgentForm({ isLoading, data = {}, onSubmit, onCancel }) {
  const showPopup = useFormFieldPopup('partner');
  const validate = useValidationSchema(validationSchema);

  return (
    <FormSection popupLineName="partner" popupLineShift="-7rem" style={{ padding: '0' }}>
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={data}
        render={({ handleSubmit, submitting, pristine, hasValidationErrors }) => (
          <form onSubmit={handleSubmit}>
            {isLoading && <Loader sticky isFillBlock />}
            {!isNil(data) && !isEmpty(data) && <PartnerItem p={data} status="Editing" className={s.negativeMargin} />}
            <Field component={FormGroupAdapter} name="emailAndCompany" type="inputGroup">
              <Field
                component={FormGroupAdapter}
                name="companyName"
                placeholder="Another Company Name"
                type="text"
                label="Company Name*"
              />

              <Field
                component={FormGroupAdapter}
                name="email"
                placeholder="janedoe@gmail.com"
                type="text"
                label="Email*"
              />
            </Field>
            <Field component={FormGroupAdapter} name="firstAndLastName" type="inputGroup">
              <Field
                component={FormGroupAdapter}
                name="consultantFirstName"
                placeholder="Jane"
                type="text"
                label="Consultant First Name"
              />

              <Field
                component={FormGroupAdapter}
                name="consultantLastName"
                placeholder="Doe"
                type="text"
                label="Consultant Last Name"
              />
            </Field>
            <Field component={FormGroupAdapter} name="firstAndLastName" type="inputGroup">
              <Field
                component={FormGroupAdapter}
                name="phone"
                placeholder="555-555-5555"
                type="text"
                label="Phone Number"
                parse={identity}
              />

              <Field
                component={FormGroupAdapter}
                name="logo"
                placeholder={UPLOAD_LOGO_PLACEHOLDER}
                placeholderWhenFilled={REPLACE_REMOVE_LOGO_PLACEHOLDER}
                type="fileLogo"
                label="Logo"
              />
            </Field>
            <Field component={FormGroupAdapter} name="brandColorGroup" type="inputGroup">
              <Field
                component={FormGroupAdapter}
                id="brandColor"
                name="primaryColor"
                placeholder="#D90000"
                type="text"
                label="Set Brand Color"
                parse={(val) => {
                  const parsed = parseHEXColor(val);

                  return isNil(parsed) ? '' : parsed;
                }}
                onFocus={showPopup(
                  <Text accent style={{ fontSize: '1.5rem' }}>
                    <b>Tool Tip:</b>
                    <br />
                    <br />
                    Don’t know the hex code? Head to{' '}
                    <a
                      href="https://imagecolorpicker.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                      style={{ fontSize: '1.3rem' }}
                    >
                      imagecolorpicker.com
                    </a>{' '}
                    to find your brand color.
                  </Text>,
                )}
              />
              <div />
            </Field>
            <FormActions isRight>
              {onCancel && (
                <Button htmlType="button" type="default" onClick={onCancel}>
                  Cancel
                </Button>
              )}
              <Button htmlType="submit" disabled={pristine || submitting || hasValidationErrors}>
                {isEmpty(data) || isNil(data) ? 'Add Partner Agent' : 'Update'}
              </Button>
            </FormActions>
            {/*<pre>{JSON.stringify(values, null, 2)}</pre>*/}
          </form>
        )}
      />
    </FormSection>
  );
}

export default PartnerAgentForm;
